import React from 'react';
import { Link } from 'react-router-dom';
import history from '../history';
import ProjectDescription from '../ProjectDescription';

class ProjectItem extends React.Component 
{
    openSketch()
    {
        history.push(this.props.project.url);
        return (
            <div>
            <Link to={`/projects/${this.props.project.id}`}/>
            </div>
        );  
    };

    render() 
    {
        return(
        <div>
            <img className="Project-Item"
                onClick={() => this.openSketch()}
                src={this.props.project.cover}
                alt={this.props.project.title}
            />
            <br/>
            <ProjectDescription text={this.props.project.description}/>
            <br/>
        </div>
        )
    }
}

export default ProjectItem;